module.exports = __webpack_public_path__ + "img/MQ.611a5d35.svg";